import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import DataTable from "react-data-table-component";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import ApiConnect from "../../../../Utils/ApiConnect";
import DeletePop from "../../../Components/DeletePop";

export default function Godown() {
  const godownList = useSelector((state) => state.Inventory.Godown);
  const [showModal, setShowmodal] = useState(false);
  const [godownname, setGodownName] = useState("");
  const [goid, setGoid] = useState("");
  const [btnDisable, SetbtnDisable] = useState(false);
  const [modalName, setModalName] = useState("");
  const [formError, setFormError] = useState(false);
  const [selectedId, SetselectedId] = useState(false);
  const [triggerModal, SettriggerModal] = useState(false);
  const [filterText, setFilterText] = useState("");
  useEffect(() => {
    fetchHandler();
  }, []);
  const handleModalClose = () => {
    setShowmodal(false);
  };
  const handleModalOpen = (e, id) => {
    setModalName(e);
    setGodownName("");
    setShowmodal(true);
    if (id) {
      setGoid(id);
      fetchHandler(id);
    }
  };
  const submitHandler = (e, type) => {
    e.preventDefault();
    SetbtnDisable(true);
    let formData = new FormData();
    formData.append("id", goid);
    formData.append("name", godownname);
    ApiConnect({
      method: "post",
      url: `/Module/Inventory/Godown/${type}Godown`,
      data: formData,
    })
      .then((response) => {
        SetbtnDisable(false);
        if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          setGodownName("");
          handleModalClose();
          fetchHandler();
        } else {
          setFormError(response.data.message);
        }
      })
      .catch((error) => console.log(error));
  };
  const dispatch = useDispatch();
  const columns = [
    {
      name: "Godown",
      selector: row => row.name,
      sortable: true,
    },
    {
      name: "Total Product",
      selector: row => row.product,
      sortable: true,
    },
    {
      name: "Action",
      selector: row => row.action,
      className: "table-actions",
      width: "150px",
      sortable: false,
      cell: (row) => {
        return (
          <React.Fragment>
            <button
              className="table-action btn btn-square btn-pure hover-warning"
              onClick={() => handleModalOpen("Edit", row.godownid)}
            >
              <span className="material-icons-outlined">edit_note</span>
            </button>
            <button
              className="table-action btn btn-square btn-pure hover-danger"
              onClick={() => {
                SetselectedId(row.id);
                SettriggerModal(true);
              }}
            >
              <span className="material-icons-outlined">delete</span>
            </button>
          </React.Fragment>
        );
      },
    },
    ];

  const customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  const filteredData = godownList.filter(
    item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(filterText.toLowerCase())
      )
  );

  const fetchHandler = (id = false) => {
    ApiConnect.get(`/Module/Inventory/Godown/Details?id=${id ? id : ""}`)
      .then((response) => {
        if (id) {
          setGodownName(response.data.name);
        } else {
          let Godown = response.data;
          dispatch({ type: "SET_INVENTORY_GODOWN", payload: { Godown } });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <div className="p-0 m-0">
      <header className="header no-border">
        <div className="header-info">
          <div className="left">
            <h2 className="header-title">
              <strong>Godown</strong>
              <small className="subtitle">
                Here you can edit,delete,view Godown.
              </small>
            </h2>
          </div>
          <div className="right gap-items-2">
            <button
              className="btn btn-primary  btn-float btn-round"
              onClick={(e) => handleModalOpen("New")}
            >
              <span className="material-icons-outlined">add</span>
            </button>
          </div>
        </div>
      </header>

      <div className="container">
        <div className="col-md-12 col-xl-12">
          <div className="card">
            <div className="card-body">
              <div className="dataTables_wrapper">
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    onChange={e => setFilterText(e.target.value)}
                  />
                </div>
                <DataTable
                  className="table table-separated"
                  keyField="id"
                  columns={columns}
                  data={filteredData}
                  pagination
                  paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                  paginationPerPage={10}
                  customStyles={customStyles}
                  filter
                  exportable
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showModal}
        className="modal-center"
        onHide={(e) => handleModalClose()}
      >
        <Modal.Dialog>
          <Modal.Header>
            <h5 className="modal-title">{modalName} Godown</h5>
            <button
              type="button"
              className="btn"
              onClick={(e) => handleModalClose()}
            >
              <span>×</span>
            </button>
          </Modal.Header>
          <form onSubmit={(e) => submitHandler(e, modalName)}>
            <Modal.Body>
              <p className="text-danger">{formError}</p>
              <label className="form-label">Godown Name</label>
              <label className="col-12">
                <input
                  type="text"
                  value={godownname}
                  className="form-control"
                  name="name"
                  required="required"
                  onChange={(e) => setGodownName(e.target.value)}
                />
              </label>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="submit"
                className="btn btn-success"
                disabled={btnDisable}
              >
                {modalName === "New" ? "Save" : "Edit"}
              </button>
            </Modal.Footer>
          </form>
        </Modal.Dialog>
      </Modal>
      <DeletePop
        trigger={triggerModal}
        delUrl={`/Module/Inventory/Godown/Delete?id=${selectedId}`}
        hideTrigger={SettriggerModal}
        fallAction={fetchHandler}
      />
    </div>
  );
}
